module.exports = __webpack_public_path__ + "static/media/Credits-14.92d22939.pdf";